import React, { useContext, useEffect, useState } from "react";
import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import TrusteeForm from "./Form";
import { TrusteeContext } from "context/TrusteeContext";
import MDActionButton from "components/MDActionButton";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";
import { trusteeList } from "Apis/trustee";
import { getTrusteeById } from "Apis/trustee";
import { deleteTrusteeById } from "Apis/trustee";

const Trustee = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
    access,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(TrusteeContext);
  const [trustee, setTrustee] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    name: "",
    address: "",
    contact_details: "",
    extra_information: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      name: filterVal?.name,
      address: filterVal?.address,
      contact_details: filterVal?.contact_details,
      extra_information: filterVal?.extra_information,
      is_active: filterVal?.is_active?.value,
    },
  };

  const trusteeData = async () => {
    let response = await trusteeList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setTrustee(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.TRUSTEE);
  }, [modules]);

  useEffect(() => {
    trusteeData();
  }, [filterVal, defaultFilter]);

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      let response = await getTrusteeById(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }
    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this member!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let deleteResponse = await deleteTrusteeById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            trustee?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            trusteeData();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse.data.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse.data.message,
              open: true,
            });
          }
        }
      });
    }
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Full Name",
        accessor: "name",
        minWidth: "85px",
        sort: true,
        filterLabel: "Full Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Address",
        accessor: "address",
        minWidth: "85px",
        sort: true,
        filterLabel: "Address",
        filterAccessor: "address",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Contact Details",
        accessor: "contact_details",
        minWidth: "126px",
        sort: true,
        filterLabel: "Contact Details",
        filterAccessor: "contact_details",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Extra Details",
        accessor: "extra_information",
        minWidth: "85px",
        sort: true,
        filterLabel: "Extra Details",
        filterAccessor: "extra_information",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="trustees"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: trustee,
  };

  return (
    !isLoading && (
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <>
            <MDModal
              hasButton={access?.write_access ?? false}
              btnText="add Trustee"
              modalHead={`${formIsEdit ? "Edit" : "Add"} trustee`}
            >
              <TrusteeForm trusteeData={trusteeData} />
            </MDModal>
            <DataTable
              table={data}
              isSorted={false}
              entriesPerPage={true}
              showTotalEntries={true}
              noEndBorder
              canFilter
              getDataList={trusteeData}
              rowCount={rowCount}
              tableTitle="Trustee List"
              defaultFilter={defaultFilter}
              setDefaultFilter={setDefaultFilter}
            />
          </>
        </DashboardLayout>
      </>
    )
  );
};
Trustee.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};
export default Trustee;
